import { jsx as _jsx } from "react/jsx-runtime";
import * as AriaKit from '@ariakit/react';
import { forwardRef } from 'react';
import * as Styles from './styles';
const Provider = AriaKit.MenuProvider;
const Menubar = AriaKit.Menubar;
const MenuButton = forwardRef(function MenuButton({ showOnHover = false, ...rest }, ref) {
    return (_jsx(AriaKit.MenuButton, { ref: ref, showOnHover: showOnHover, ...rest, onFocus: (e) => {
            rest.onFocus?.(e);
            if (showOnHover === false)
                e.preventDefault();
        } }));
});
const _Menu = forwardRef(function Menu({ unmountOnHide = true, ...rest }, ref) {
    return _jsx(Styles.Menu, { ref: ref, unmountOnHide: unmountOnHide, ...rest });
});
const MenuItem = AriaKit.MenuItem;
const MenuItemCheckbox = AriaKit.MenuItemCheckbox;
const MenubarButton = forwardRef(function MenubarButton({ focusOnHover = false, render, ...rest }, ref) {
    return (_jsx(AriaKit.MenuItem, { ref: ref, focusOnHover: focusOnHover, render: _jsx(MenuButton, { showOnHover: focusOnHover, render: render }), ...rest }));
});
function useMenuState() {
    const menuCtx = AriaKit.useMenuContext();
    if (!menuCtx) {
        throw new Error('You must use `useMenuState` within a `Menu.Provider`.');
    }
    const menuState = AriaKit.useStoreState(menuCtx);
    return { ...menuState, ...menuCtx };
}
export const Menu = {
    Provider,
    Menu: _Menu,
    Menubar,
    MenuButton,
    MenuItem,
    MenuItemCheckbox,
    MenubarButton,
    useState: useMenuState,
};
//# sourceMappingURL=index.js.map